import { useContext } from 'react';
import { reactKeycloakSsrContext } from './internals/context';
import { isServer } from './internals/utils';
export function useKeycloak() {
    var _a = useContext(reactKeycloakSsrContext), initialized = _a.initialized, authClient = _a.authClient;
    var initializedVar = initialized || isServer();
    return {
        initialized: initializedVar,
        keycloak: authClient,
    };
}
//# sourceMappingURL=useKeycloak.js.map